"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabsStyles = exports.tabVars = exports.tabCommon = void 0;
var _Text = require("../../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _commonProps = require("../../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var tabCommon = exports.tabCommon = _commonProps.defaultCommonProps;
var tabVars = exports.tabVars = (0, _initVars.default)({
  applied: tabCommon
});
var styles = function styles(theme) {
  return {
    variables: tabVars.styles,
    root: _objectSpread(_objectSpread({
      outline: 0,
      background: "transparent",
      height: theme.spacing.base * 6,
      position: "relative",
      fontFamily: theme.typography.fontFamily
    }, (0, _Text.setTextCssVars)({
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize + 2,
      color: theme.colors.baseContrast090,
      lineHeight: 1
    })), {}, {
      textTransform: "capitalize",
      cursor: "pointer",
      border: "none",
      "&:hover": {
        background: theme.colors.baseContrast015
      }
    }),
    label: {
      pointerEvents: "none",
      "& :first-child": {
        display: "inline-flex",
        alignItems: "center"
      },
      "& svg": {
        marginInlineEnd: theme.spacing.base / 2
      }
    },
    expand: {
      width: "100%",
      padding: [theme.spacing.base, 0]
    },
    contentSize: {
      width: "unset",
      padding: [theme.spacing.base, theme.spacing.base * 2]
    },
    indicator: {
      borderBottom: "solid 2px ".concat(theme.colors.primary),
      padding: [theme.spacing.base, theme.spacing.base * 2, theme.spacing.base - 2, theme.spacing.base * 2]
    },
    selected: {}
  };
};
var useTabsStyles = exports.useTabsStyles = (0, _createUseStyles.default)(styles, {
  name: "Tab"
});